import axios from "axios";

const prepareData = (data) => { return { approval: data } }

// Plural Actions
export const GET_APPROVALS = "get_approvals";
export const getApprovals = () => {
	const url = `/approvals.json`
	const request = axios.get(url);
	return {
		type: GET_APPROVALS,
		payload: request
	};
};

export const GET_APPROVAL = "get_approval";
export const getApproval = (id) => {
	const url = `/approvals/${id}.json`
	const request = axios.get(url);
	return {
		type: GET_APPROVAL,
		payload: request
	};
};